import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LearnerHome from "../LearnerHome/LearnerHome";
import PublicHome from "../PublicHome/PublicHome";

const HomePage = (props: any) => {
  const commonInfo = useSelector((state: any) => state.common);
  const allInfo = useSelector((state: any) => state);
  const [isAdmin, setAdmin] = useState(false);

  useEffect(() => {
    var peopleCallDataInformation = allInfo.peopleInformation.data;
    if (!!peopleCallDataInformation && peopleCallDataInformation.getpeopleInformation) {
      let adminCheck = peopleCallDataInformation.getpeopleInformation.license.filter((pId: any) => {
        return pId.productId === "13";
      }).length;
      if (adminCheck > 0) {
        setAdmin(true);
      }
    }
  }, allInfo.peopleInformation.data);

  const isLearnerTaskCompleted = () => {
    let filteredResp;
    const respData = allInfo.learnerTasks.data.getLearnerTasks ? allInfo.learnerTasks.data.getLearnerTasks : [];
    if (respData.length > 0) {
      filteredResp = respData.filter((taskObj: any) => {
        return `${taskObj.taskid}` === "1";
      });
    }
    if (isAdmin) {
      return isAdmin;
    } else {
      return filteredResp && filteredResp.length > 0 && filteredResp[0].status;
    }
  };

  return (
    <div>
      {!!!allInfo.learnerTasks.isLoading &&
      !!allInfo.learnerTasks.data &&
      !!!commonInfo.isLoading &&
      !!commonInfo.isUserAuthenticated ? (
        <div>
          {isLearnerTaskCompleted() ? (
            <div className="HomePageContainer">
              <LearnerHome authProps={{ ...props }} isEnglishUser={props.isEnglishUser} />
            </div>
          ) : (
            <Navigate to="/welcome" />
          )}
        </div>
      ) : (
        <div className="HomePageContainer">
          <PublicHome authProps={{ ...props }} />
        </div>
      )}
    </div>
  );
};

export default HomePage;
